import styled from 'styled-components';
export const Text = styled.span `
  font-size: ${({ size }) => size || 14}px;
  line-height: ${({ size, lineHeight }) => {
    if (typeof lineHeight === 'string') {
        if (lineHeight === 'body') {
            if (size === 12)
                return '16px';
            if (size === 14)
                return '20px';
            if (size === 16)
                return '22px';
            if (size === 20)
                return '28px';
            if (size === 24)
                return '32px';
            if (size === 32)
                return '40px';
            return '1.5';
        }
        return lineHeight;
    }
    if (size === 12 || size === 14)
        return '16px';
    return `${(size || 12) + 4}px`;
}};

  font-weight: ${({ weight }) => {
    if (weight === 'normal')
        return 400;
    if (weight === 'medium')
        return 500;
    if (weight === 'semibold')
        return 600;
    return weight;
}};

  color: ${({ theme, color }) => {
    if (!color)
        return theme.secondary.background;
    if (typeof color === 'string' &&
        !['light', 'lighter', 'foreground', 'danger', 'success', 'primary', 'warning'].includes(color)) {
        return color;
    }
    switch (color) {
        case 'light':
            return theme.secondary.blendToBackground(800);
        case 'lighter':
            return theme.secondary.blendToBackground(500);
        case 'foreground':
            return theme.foreground;
        case 'danger':
            return theme.danger.background;
        case 'success':
            return theme.success.background;
        case 'primary':
            return theme.primary.background;
        case 'warning':
            return theme.warning.background;
        default:
            return theme.secondary.background;
    }
}};

  letter-spacing: ${({ letterSpacing }) => {
    if (letterSpacing === 'tight')
        return '-0.01em';
    if (letterSpacing === 'tighter')
        return '-0.02em';
    if (letterSpacing === 'tightest')
        return '-0.03em';
    return '0';
}};

  margin: ${({ margin }) => margin};
  font-family: ${({ monospace }) => monospace && 'monospace'};
  white-space: ${({ whiteSpace }) => whiteSpace};
  max-width: 96ch;
`;
export const Headline = styled.h1 `
  font-family: inherit;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  line-height: 20px;
  color: ${({ theme }) => theme.foreground};
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '36ch')};
  text-align: ${({ align, fullWidth }) => align ?? (fullWidth ? 'center' : 'left')};

  small {
    vertical-align: baseline;
    color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  }
`;
export const Paragraph = styled.div `
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: ${({ theme }) => theme.secondary.background};
  text-align: ${({ align, fullWidth }) => align ?? (fullWidth ? 'center' : 'left')};
`;
//# sourceMappingURL=Typography.js.map